// Minimal no-op replacement for the nprogress API surface dacom components use.
// The original rendered a thin top-of-page loading bar; cropr_project shows
// loading state via Loader/LoadError components already, so we drop the bar and
// keep only the call sites working.
const NProgress = {
  start() {},
  done() {},
  set(_value) {},
  inc(_value) {},
  configure(_opts) {},
};

export default NProgress;
